module.exports = __webpack_public_path__ + "img/Summer-Challenge.fe65190e.svg";